import { useState } from "react";
import { MessageBubble } from "@/components/chat/MessageBubble";
import { Message } from "@/types/message";

const ComponentTest = () => {
  const [editingMessageId, setEditingMessageId] = useState<string | null>(null);

  const sampleMessage: Message = {
    id: "test-1",
    role: "assistant",
    content: "# Hello!\n\nThis is a **sample AI response** with some `code` and a [link](https://example.com).\n\n- Item 1\n- Item 2\n- Item 3",
    is_latest_ai: true,
    created_at: new Date().toISOString(),
  };

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-3xl mx-auto space-y-4">
        <h1 className="text-2xl font-bold mb-6">Component Preview: MessageBubble</h1>
        <MessageBubble
          message={sampleMessage}
          onEdit={(id) => setEditingMessageId(id)}
          isEditing={editingMessageId === sampleMessage.id}
          onCancelEdit={() => setEditingMessageId(null)}
          onSaveEdit={(content) => {
            console.log("Save edit:", content);
            setEditingMessageId(null);
          }}
          onSummarize={(summary) => console.log("Summary:", summary)}
          onSend={(summary) => console.log("Send:", summary)}
        />
      </div>
    </div>
  );
};

export default ComponentTest;
